import { render, staticRenderFns } from "./NewDetailPage.vue?vue&type=template&id=0c05a3d9&scoped=true"
import script from "./NewDetailPage.vue?vue&type=script&lang=js"
export * from "./NewDetailPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/newDetailPage.scss?vue&type=style&index=0&id=0c05a3d9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c05a3d9",
  null
  
)

export default component.exports